/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kTSMroKPFv65RRTb44SCtk
// Component: HSPuw3LccxMD

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: kTSMroKPFv65RRTb44SCtk/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../user_mentions/plasmic.css"; // plasmic-import: kTSMroKPFv65RRTb44SCtk/projectcss
import sty from "./PlasmicUserMentionDisplay.module.css"; // plasmic-import: HSPuw3LccxMD/css

createPlasmicElementProxy;

export type PlasmicUserMentionDisplay__VariantMembers = {};
export type PlasmicUserMentionDisplay__VariantsArgs = {};
type VariantPropType = keyof PlasmicUserMentionDisplay__VariantsArgs;
export const PlasmicUserMentionDisplay__VariantProps =
  new Array<VariantPropType>();

export type PlasmicUserMentionDisplay__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicUserMentionDisplay__ArgsType;
export const PlasmicUserMentionDisplay__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicUserMentionDisplay__OverridesType = {
  root?: Flex__<"span">;
};

export interface DefaultUserMentionDisplayProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicUserMentionDisplay__RenderFunc(props: {
  variants: PlasmicUserMentionDisplay__VariantsArgs;
  args: PlasmicUserMentionDisplay__ArgsType;
  overrides: PlasmicUserMentionDisplay__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <span
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "span",
        "span__kTSMr",
        "root_reset_kTSMroKPFv65RRTb44SCtk",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <div className={classNames("all", "__wab_text", sty.text__gSlk)}>
            {"User name"}
          </div>
        ),
        value: args.children,
        className: classNames(sty.slotTargetChildren),
      })}
    </span>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "span";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicUserMentionDisplay__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicUserMentionDisplay__VariantsArgs;
    args?: PlasmicUserMentionDisplay__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicUserMentionDisplay__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicUserMentionDisplay__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicUserMentionDisplay__ArgProps,
          internalVariantPropNames: PlasmicUserMentionDisplay__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicUserMentionDisplay__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicUserMentionDisplay";
  } else {
    func.displayName = `PlasmicUserMentionDisplay.${nodeName}`;
  }
  return func;
}

export const PlasmicUserMentionDisplay = Object.assign(
  // Top-level PlasmicUserMentionDisplay renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicUserMentionDisplay
    internalVariantProps: PlasmicUserMentionDisplay__VariantProps,
    internalArgProps: PlasmicUserMentionDisplay__ArgProps,
  }
);

export default PlasmicUserMentionDisplay;
/* prettier-ignore-end */
